/**
 * @generated SignedSource<<b301f0c56f2e8ec78c0ba5c963f8e2bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionDriverField_DriverField$data = {
  readonly driverData: {
    readonly driver: {
      readonly accountId: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
    readonly queryError: {
      readonly message: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly project: {
    readonly projectId: string;
  };
  readonly " $fragmentType": "ui_softwareReleasesVersionDriverField_DriverField";
};
export type ui_softwareReleasesVersionDriverField_DriverField$key = {
  readonly " $data"?: ui_softwareReleasesVersionDriverField_DriverField$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDriverField_DriverField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesVersionDriverField_DriverField",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "projectId"
            },
            "action": "THROW",
            "path": "project.projectId"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    },
    {
      "concreteType": "JiraVersionDriverResult",
      "kind": "LinkedField",
      "name": "driverData",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "driver",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "accountId"
              },
              "action": "THROW",
              "path": "driverData.driver.accountId"
            },
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "name"
              },
              "action": "THROW",
              "path": "driverData.driver.name"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "queryError",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "699193bd41c7f6c4d596a3dd505592df";

export default node;
